import { Divider, ScrollArea, Stack } from "@mantine/core";
import { useParams } from "@tanstack/react-router";

import { useCurrentWorkspace } from "@/api/resources/workspaces/hooks";
import NavbarIconGroupItem from "@/components/Navbar/NavbarIconGroupItem";
import NavbarIconListItem from "@/components/Navbar/NavbarIconListItem";
import {
  isNavigationGroup,
  useNavigationElementsDeployment,
  useNavigationElementsWorkspace,
} from "@/components/Navbar/useNavigationElements";
import { BusinessType } from "@/supabase.types";

export const NavbarIconList = () => {
  const { workspace_id } = useParams({ strict: false });
  const { data: currentWorkspace } = useCurrentWorkspace();

  let canManageChildWorkspaces = false;
  if (currentWorkspace?.business_type === BusinessType.service_provider) {
    canManageChildWorkspaces = true;
  }
  if (currentWorkspace?.business_type === BusinessType.manufacturer) {
    canManageChildWorkspaces = true;
  }

  const navigationElementsWorkspace = useNavigationElementsWorkspace(workspace_id, canManageChildWorkspaces);
  const navigationElementsDeployment = useNavigationElementsDeployment(workspace_id);

  if (!workspace_id) return null;

  return (
    <ScrollArea.Autosize>
      <Stack gap={4}>
        <Divider my="xs" px="xs" />
        {navigationElementsWorkspace.map((navElement) => {
          if (isNavigationGroup(navElement)) {
            return (
              <NavbarIconGroupItem key={navElement.title} navGroup={navElement}>
                {({ close }) =>
                  navElement.items.map((navElementChild) => (
                    <NavbarIconListItem key={navElementChild.title} navigationItem={navElementChild} onClose={close} />
                  ))
                }
              </NavbarIconGroupItem>
            );
          }
          return <NavbarIconListItem key={navElement.title} navigationItem={navElement} />;
        })}

        <Divider my="xs" px="xs" />

        {navigationElementsDeployment.map((navElement) => {
          if (isNavigationGroup(navElement)) {
            return (
              <NavbarIconGroupItem key={navElement.title} navGroup={navElement}>
                {({ close }) =>
                  navElement.items.map((navElementChild) => (
                    <NavbarIconListItem key={navElementChild.title} navigationItem={navElementChild} onClose={close} />
                  ))
                }
              </NavbarIconGroupItem>
            );
          }
          return <NavbarIconListItem key={navElement.title} navigationItem={navElement} />;
        })}
      </Stack>
    </ScrollArea.Autosize>
  );
};

export default NavbarIconList;
